import { BeelineResult } from '../beelineLp/BeelineLanding';

export default function Beeline3Success() {
  return <BeelineResult lpKey="beeline3" outcome="success" variant={3} />;
}
